<template>
    <div :id="'modal-sms-create-form-'+_uid" class="modal fade modal-size-600" tabindex="-1" role="dialog"
         aria-labelledby="smsCreateFormModal"
         aria-hidden="true"
         style="display: none;">

        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-normal" id="modalTitle">New SMS</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>

                <div class="modal-body full-height-scroll limit-modal-height">
                    <form class="form with-elementio-elements">
                        <div class="form-group">
                            <div class="col-md-12 p-0">
                                <label style="display:inherit">Select Contact (Optional)</label>

                                <el-select class="col-md-12" style="padding:0"
                                           v-model="selectedContact"
                                           placeholder="Select Contact"
                                           :clearable=true
                                           value-key="id"
                                           no-data-text="No contacts linked to select from"
                                           :filterable="true">

                                    <el-option
                                        v-for="contact in contactSuggestions"
                                        :value="contact"
                                        :key="contact.id"
                                        :label="'(' + $options.filters.titlecase(contact.pivot.role) + ') ' + contact.full_name"
                                        style="padding: 5px 10px">
                                        <div>
                                            <div class="content-group">
                                                <h6 class="">
                                                    <span class="label label-light-primary mr-1" style="line-height: 14px !important;">
                                                        {{ contact.pivot.role | titlecase }}
                                                    </span>

                                                    {{ contact.full_name !== "Unnamed Record" ? contact.full_name : contact.contact_name }}
                                                    {{ contact.mobile === null ? " (No Mobile)" : "" }}

                                                    <span class="badge badge-pill badge-muted"
                                                          v-if="contact.pivot.status === 'archived'">archived</span>

                                                    <i v-if="contact.pivot.primary" class="mdi mdi-approval"
                                                       data-toggle="tooltip"
                                                       data-original-title="Primary Contact"></i>
                                                </h6>
                                            </div>
                                        </div>
                                    </el-option>
                                </el-select>

                                <span class="invalid-feedback"
                                      :class="{'d-block': form.errors.has('contact')}"
                                      v-show="form.errors.has('contact')">
                                    @{{ form.errors.get("contact") }}
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="mobile">Mobile</label>

                            <!--Number input allows 'e' and minus so we ignore the input if it is one of those-->
                            <input class="form-control" type="number" id="mobile" name="mobile"
                                   required
                                   placeholder="0820004444"
                                   onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                                   @keydown="form.errors.forget('mobile')"
                                   v-model="form.mobile"
                                   :class="{'is-invalid': form.errors.has('mobile')}">

                            <span class="invalid-feedback" v-show="form.errors.has('mobile')">
                                {{ form.errors.get("mobile") }}
                            </span>
                        </div>

                        <div class="form-group">
                            <label>Saved Replies</label>
                            <el-select class="w-100"
                                       @change="getPopulatedContent"
                                       v-model="selectedSavedReply"
                                       placeholder="Use Saved Reply (Optional)"
                                       :loading="loadingSavedReplies"
                                       value-key="id"
                                       :filterable=true
                                       loading-text="Fetching Saved Replies">
                                <el-option
                                    class="checklist-set-dropdown"
                                    v-for="reply in savedRepliesList"
                                    :key="reply.id"
                                    :label="reply.name"
                                    :value="reply.id">
                                    <div style="max-width: 500px">
                                        <span class="font-medium" style="line-height: 12px !important">{{ reply.name }}</span>
                                        <div>
                                            <p class="small text-muted" style="line-height: 1em !important;">{{ reply.body }}</p>
                                        </div>
                                    </div>
                                </el-option>
                            </el-select>
                        </div>

                        <div class="form-group">
                            <div class="flex flex-col md:flex-row md:justify-between md:items-center">
                                <label for="message">Message</label>

                                <p class="flex items-center text-sm pr-1"
                                   :class="smsCharsRemaining < 0 ? 'text-red-600' : 'text-gray-400'">
                                    {{ smsCharsRemaining }}
                                </p>
                            </div>

                            <textarea class="form-control"
                                      style="height: 160px; font-size: 12px"
                                      required
                                      id="message"
                                      name="message"
                                      :maxlength="smsMaxLength"
                                      @keydown="form.errors.forget('message')"
                                      v-model="form.message"
                                      :class="{'is-invalid': form.errors.has('message')}">
                            </textarea>

                            <span class="pull-right">{{ numberOfCredits + " SMS credit" | pluralizeOnlyS(numberOfCredits) }}</span>
                            <span class="invalid-feedback" v-show="form.errors.has('message')">
                                {{ form.errors.get("message") }}
                            </span>
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-success waves-effect waves-light"
                            @click.prevent="sendSMS"
                            :disabled="form.busy">{{ form.busy ? "Sending..." : "Send Sms" }}
                    </button>
                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            @click.prevent="hideSMSCreateForm"
                            :disabled="form.busy">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TagGroupsMixin from "../../mixins/tag-groups-mixin";

export default {
    name: "create-new-sms",

    props: ["category", "contact", "contactable", "contactableId", "contactList", "selectedActivity"],

    mixins: [TagGroupsMixin],

    data () {
        return {
            id: null,
            loadingSavedReplies: true,
            savedRepliesList: null,
            selectedSavedReply: null,
            contactSuggestions: this.contactList,
            selectedContact: this.contact ? this.contact.id : undefined,
            type: "SMS",
            form: new AppForm({message: ""}),
            smsMaxLength: 459,
        };
    },

    created () {
        this.resetForm();

        let self = this;
        Bus.$on("show-sms-create-form", function (contact) {
            self.selectedContact = contact;
            self.showSMSCreateForm();
        });
    },

    watch: {
        selectedContact (newValue) {
            if (newValue) {
                this.form.contact_id = newValue.id;
                this.form.mobile = newValue.mobile;
                this.form.contact_role = newValue.pivot.role;
            } else {
                this.resetForm();
            }
        }
    },

    computed: {
        numberOfCredits () {
            //https://docs.smsportal.com/docs/website-sending-a-bulk-sms sms segment break down
            if (this.form && this.form.message) {
                if (this.form.message.length < 161) {
                    return 1;
                } else if (this.form.message.length < 307) {
                    return 2;
                } else if (this.form.message.length < 460) {
                    return 3;
                }

                return "Over the limit";
            } else {
                return 0;
            }
        },

        smsCharsRemaining () {
            return this.smsMaxLength - this.form.message.length;
        }
    },

    methods: {
        showSMSCreateForm () {
            $("#modal-sms-create-form-" + this._uid).modal("show");
            this.fetchContactSuggestions();
            this.fetchSavedReplyOptions();
        },

        hideSMSCreateForm () {
            this.selectedSavedReply = null;
            this.selectedContact = null;
            this.resetForm();
            $("#modal-sms-create-form-" + this._uid).modal("hide");
        },

        resetForm () {
            this.form = new AppForm({
                contactable: this.contactable,
                contactableId: this.contactableId,
                message: "",
                mobile: null
            });
        },

        getPopulatedContent (reply) {
            App.post("/savedreplies/context/populate", new AppForm({
                contentString: this.selectedSavedReply.id,
                contactable: this.contactable,
                contactable_id: this.contactableId,
                selectedContact: this.selectedContact ? this.selectedContact.id : null,
                selectedActivity: this.selectedActivity ? this.selectedActivity.id : null,
                selectedSavedReply: reply,
                selected_contact: this.selectedContact,
                return_html: false
            })).then((response) => {
                this.form.message = response;
                this.selectedSavedReply = null;
            }).catch(() => {
                toastr.error("Could not fetch tags");
                this.form.message = reply.body;
                this.selectedSavedReply = null;
            });
        },

        fetchSavedReplyOptions () {
            this.loadingSavedReplies = true;
            axios.get("/savedreplies/context/all", {
                params: {
                    category: this.category,
                    type: this.type
                }
            }).then((response) => {
                this.savedRepliesList = response.data;
                this.loadingSavedReplies = false;
            }).catch(() => {
                this.loadingSavedReplies = false;
                toastr.error("Could not load saved replies!");
            });
        },

        fetchContactSuggestions () {
            axios.get("/sms/get-contact-suggestions", {
                params: {
                    contactable: this.contactable,
                    contactable_id: this.contactableId
                }
            }).then((response) => {
                this.contactSuggestions = response.data;
            }).catch(() => {
                toastr.error("Could not get contact suggestions!");
            });
        },

        sendSMS () {
            if (this.form.message && this.getAllTags().some(tag => this.form.message.includes(tag))) {
                this.form.setErrors({message: ["You have unfilled tags! Look for the ## ## and resolve them!"]});
            } else {
                switch (this.contactable) {
                    case "App\\Ticket" :
                        this.sendSMSToSpecifiedUri("/tickets/" + this.contactableId + "/sms/create");
                        break;

                    case "App\\Inspection":
                        this.sendSMSToSpecifiedUri("/inspections/" + this.contactableId + "/sms/create");
                        break;

                    default:
                        this.sendSMSToSpecifiedUri("/sms/create");
                }
            }
        },

        sendSMSToSpecifiedUri (uri) {
            App.post(uri, this.form)
            .then((response) => {
                toastr.success("SMS sent to " + this.form.mobile);
                this.hideSMSCreateForm();
                this.$emit("new-sms-sent");
            }).catch((errors) => {
                toastr.error("Could not send sms");
            });
        }
    }
};
</script>

<style scoped>
.my-autocomplete li {
    line-height: normal;
    padding: 7px;
}

.my-autocomplete .value {
    text-overflow: ellipsis;
    overflow: hidden;
}

.my-autocomplete .link {
    font-size: 12px;
    color: #b4b4b4;
}

/* Remove arrows on number input */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    /*margin: 0; !* Remove left over margin  *!*/
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
